import {ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {windowScroll} from "../../services/window-scrolling.service";
import {ToastService} from "../../services/Toast.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";

declare let _: any;

@Component({
  selector: 'app-strategy-tags-search',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent],
  templateUrl: './strategy-tags-search.component.html',
  styleUrl: './strategy-tags-search.component.scss'
})
export class StrategyTagsSearchComponent implements OnInit, OnDestroy {
  org: any;
  searchModel: any;
  searchTags: Array<any> = [];
  reveal: any = {
    search: false
  };

  categoryOptions: Array<any> = [];
  applicableToOptions: Array<any> = [
    { value: 'Business', label: 'Business' },
    { value: 'Individual', label: 'Individual' },
    { value: 'Both', label: 'Both' }
  ];
  complexityOptions: Array<any> = [
    { value: '1', label: '1 - Single Input' },
    { value: '2', label: '2 - Multiple Inputs' },
    { value: '3', label: '3 - Conditional' },
    { value: '4', label: '4 - Complex' },
    { value: '5', label: '5 - Specialized' }
  ];

  urgencyOptions: Array<any> = [
    { value: 'No deadline', label: 'No deadline' },
    { value: 'Annual', label: 'Annual' },
    { value: 'Quarterly', label: 'Quarterly' },
    { value: 'Weeks', label: 'Weeks' },
    { value: 'Days', label: 'Days' }
  ];

  riskOptions: Array<any> = [
    { value: 'Sustained', label: '1 - Minimal' },
    { value: 'More Likely Than Not', label: '2 - Low' },
    { value: 'Substantial Authority', label: '3 - Moderate' },
    { value: 'Reasonable Basis', label: '4 - Heightened' },
    { value: 'Listed/Reportable', label: '5 - Significant' }
  ];

  burdenOptions: Array<any> = [
    { value: 'Referral only', label: '1 - Mostly the client' },
    { value: 'Light coordination', label: '2 - Client with advisor help' },
    { value: 'Shared work', label: '3 - Half client/advisor' },
    { value: 'Mostly advisor', label: '4 - Mostly tax advisor' },
    { value: 'All advisor (no vendor)', label: '5 - Concierge' }
  ];

  amountTypeOptions: Array<any> = [
    { value: 'Credit', label: 'Credit' },
    { value: 'Deduction', label: 'Deduction' },
    { value: 'Deduction/Credit', label: 'Deduction/Credit' },
    { value: 'Deduction/Deferral', label: 'Deduction/Deferral' },
    { value: 'Deduction/Exclusion', label: 'Deduction/Exclusion' },
    { value: 'Deduction/Shifting', label: 'Deduction/Shifting' },
    { value: 'Deferral', label: 'Deferral' },
    { value: 'Exclusion', label: 'Exclusion' },
    { value: 'Exclusion/Shifting', label: 'Exclusion/Shifting' },
    { value: 'Shifting', label: 'Shifting' }
  ];

  requiresInvestmentOptions: Array<any> = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ];

  @Input() set tags(searchtag) {
    this.searchTags = searchtag;
  }
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  tagsList: Array<any> = [];
  user: string;
  displayTags = true;
  statusTypes: Array<any> = [{name: 'Active'}, {name: 'Archived'}, {name: 'All'}];
  multiSelectFilterKeys: string[] = ['category', 'complexity', 'urgency', 'riskLevel', 'burden', 'amountType'];
  multiSelectDropdownState: any = {
    category: false,
    complexity: false,
    urgency: false,
    riskLevel: false,
    burden: false,
    amountType: false
  };

  constructor(private switchBoard: SwitchBoard,
              private toastService: ToastService, private windowScroll: windowScroll,
              private changeDetectionRef: ChangeDetectorRef,
              private taxStrategyServices: ManageTaxStrategiesServices) {
    this.switchBoard.onSearchTagDelete.pipe(takeUntil(this.destroy$)).subscribe(search => {
      if (search && search.searchItem && search.searchItem.key == 'status') {
        this.searchModel.status = '';
      } else if (search && search.searchItem && search.searchItem.key == 'selectedTags') {
        this.searchModel.selectedTags = [];
      } else if (search && search.searchItem && search.searchItem.key === 'complexity') {
        this.searchModel.complexity = [];
      } else if (search && search.searchItem && search.searchItem.key === 'category') {
        this.searchModel.category = [];
      } else if (search && search.searchItem && search.searchItem.key === 'urgency') {
        this.searchModel.urgency = [];
      } else if (search && search.searchItem && search.searchItem.key === 'riskLevel') {
        this.searchModel.riskLevel = [];
      } else if (search && search.searchItem && search.searchItem.key === 'burden') {
        this.searchModel.burden = [];
      } else if (search && search.searchItem && search.searchItem.key === 'amountType') {
        this.searchModel.amountType = [];
      } else if (search && search.searchItem && search.searchItem.key === 'requiresInvestment') {
        this.searchModel.requiresInvestment = '';
      } else if (search && search.searchItem && search.searchItem.key === 'applicableTo') {
        this.searchModel.applicableTo = '';
      }
      this.advanceTasksSearch();
    });
  }

  ngOnInit(): void {
    this._init();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.searchModel =  {
      selectedTags: [],
      status: 'Active',
      category: [],
      complexity: [],
      urgency: [],
      riskLevel: [],
      burden: [],
      amountType: [],
      requiresInvestment: '',
      applicableTo: ''
    };
    this.getFirmTagsData();
    this.loadCategoryOptions();
    this.updateModel();
  }

  getFirmTagsData() {
    this.taxStrategyServices.getTagsDataForFirm(this.org, this.user)
      .subscribe(response => {
        this.tagsList = response || [];
      }, error => {
      });
  }

  loadCategoryOptions() {
    const req: any = {fromIndex: 0, sortKey: 'name', sortOrder: 'asc'};
    this.taxStrategyServices.getPaginatedTaxStrategies(this.org, this.user, req, null, null, 'Active')
      .subscribe(response => {
        const categories = _.uniq(_.compact(_.map(response?.strategies || [], 'type')));
        this.categoryOptions = categories.map((c: string) => ({ value: c, label: c }));
      }, error => {
      });
  }

  updateModel() {
    for (const i in this.searchTags) {
      if (this.searchTags[i].modelValue !== undefined && this.searchTags[i].modelValue !== null) {
        if (this.isMultiSelectFilter(this.searchTags[i].key)) {
          this.searchModel[this.searchTags[i].key] = this.normalizeMultiSelectValue(this.searchTags[i].modelValue);
        } else {
          this.searchModel[this.searchTags[i].key] = this.searchTags[i].modelValue;
        }
      } else {
        if (this.isMultiSelectFilter(this.searchTags[i].key)) {
          this.searchModel[this.searchTags[i].key] = this.normalizeMultiSelectValue(this.searchTags[i].value);
        } else {
          this.searchModel[this.searchTags[i].key] = this.searchTags[i].value;
        }
      }
    }
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.closeAllMultiSelectDropdowns();
  }

  isMultiSelectFilter(key: string): boolean {
    return this.multiSelectFilterKeys.includes(key);
  }

  normalizeMultiSelectValue(value: any): Array<string> {
    if (Array.isArray(value)) {
      return _.compact(value);
    }
    if (!value || typeof value !== 'string') {
      return [];
    }
    return _.compact(value.split(',').map((item: string) => item.trim()));
  }

  toggleMultiSelect($event, key: string) {
    $event.stopImmediatePropagation();
    const nextValue = !this.multiSelectDropdownState[key];
    this.closeAllMultiSelectDropdowns();
    this.multiSelectDropdownState[key] = nextValue;
  }

  closeAllMultiSelectDropdowns() {
    _.forEach(this.multiSelectFilterKeys, (key) => {
      this.multiSelectDropdownState[key] = false;
    });
  }

  isMultiSelectOpen(key: string): boolean {
    return !!this.multiSelectDropdownState[key];
  }

  getOptionsByFilterKey(key: string): Array<any> {
    const map: any = {
      category: this.categoryOptions,
      complexity: this.complexityOptions,
      urgency: this.urgencyOptions,
      riskLevel: this.riskOptions,
      burden: this.burdenOptions,
      amountType: this.amountTypeOptions
    };
    return map[key] || [];
  }

  getOptionValue(option: any): string {
    return option?.value || option?.name || option?.label || '';
  }

  normalizeSelectValue(value: any): string {
    return String(value ?? '').trim();
  }

  getOptionLabel(option: any): string {
    return option?.label || option?.value || option?.name || '';
  }

  getMultiSelectDisplayValue(key: string, placeholder: string): string {
    const selectedValues = this.searchModel[key] || [];
    if (!selectedValues.length) {
      return placeholder;
    }
    const options = this.getOptionsByFilterKey(key);
    const labels = selectedValues.map((selectedValue) => {
      const selectedOption = _.find(options, (option) => this.getOptionValue(option) === selectedValue);
      return selectedOption ? this.getOptionLabel(selectedOption) : selectedValue;
    });
    return labels.join(', ');
  }

  getSelectedCount(key: string): number {
    return (this.searchModel[key] || []).length;
  }

  isOptionSelected(filterKey: string, option: any): boolean {
    const selectedValues = (this.searchModel[filterKey] || []).map((value) => this.normalizeSelectValue(value));
    const optionValue = this.normalizeSelectValue(this.getOptionValue(option));
    return selectedValues.includes(optionValue);
  }

  onMultiSelectOptionChange(filterKey: string, option: any, $event: any) {
    $event.stopImmediatePropagation();
    const isChecked = !!$event.target?.checked;
    const optionValue = this.normalizeSelectValue(this.getOptionValue(option));
    const selectedValues = [...(this.searchModel[filterKey] || [])].map((value) => this.normalizeSelectValue(value));
    if (isChecked) {
      selectedValues.push(optionValue);
      this.searchModel[filterKey] = _.uniq(selectedValues);
    } else {
      this.searchModel[filterKey] = selectedValues.filter((value) => value !== optionValue);
    }
  }

  getSelectedOptions(filterKey: string): Array<{ value: string; label: string }> {
    const options = this.getOptionsByFilterKey(filterKey);
    const selectedValues = (this.searchModel[filterKey] || []).map((value) => this.normalizeSelectValue(value));
    return selectedValues.map((selectedValue) => {
      const selectedOption = _.find(options, (option) => this.normalizeSelectValue(this.getOptionValue(option)) === selectedValue);
      return {
        value: selectedValue,
        label: selectedOption ? this.getOptionLabel(selectedOption) : selectedValue
      };
    });
  }

  removeMultiSelectValue(filterKey: string, value: string, $event?: any) {
    if ($event) {
      if (typeof $event.preventDefault === 'function') {
        $event.preventDefault();
      }
      $event.stopImmediatePropagation();
    }
    const selectedValues = [...(this.searchModel[filterKey] || [])];
    const normalizedValue = String(value ?? '').trim();
    this.searchModel[filterKey] = selectedValues
      .map((entry) => String(entry ?? '').trim())
      .filter((entry) => entry !== normalizedValue);
  }

  getSelectedMultiFilterLabel(key: string): string {
    const options = this.getOptionsByFilterKey(key);
    const selectedValues = (this.searchModel[key] || []).map((value) => this.normalizeSelectValue(value));
    const labels = selectedValues.map((selectedValue) => {
      const selectedOption = _.find(options, (option) => this.normalizeSelectValue(this.getOptionValue(option)) === selectedValue);
      return selectedOption ? this.getOptionLabel(selectedOption) : selectedValue;
    });
    return labels.join(',');
  }

  toggle($event){
    this.closeAllMultiSelectDropdowns();
    this.reveal = {...this.reveal, search: true};
  }

  trackByOptionValue(index: number, item: { value: string; label: string }): string {
    return item.value;
  }


  hideReveal(revealFlag){
    this.windowScroll.enable();
    this.reveal[revealFlag] = false;
    if (!(this.changeDetectionRef as ViewRef).destroyed) {
      this.changeDetectionRef.detectChanges();
    }
  }

  removeFromSelectedList($event, index, data) {
    $event.stopImmediatePropagation();
    data.splice(index, 1);
  }

  advanceTasksSearch(closePopup: boolean = true){
    let tags = this.getSelectedNames(this.searchModel.selectedTags, 'label');
    let searchFilters = _.map(this.searchModel.selectedTags, 'id');
    const selectedCategories = this.searchModel.category || [];
    const selectedComplexities = this.searchModel.complexity || [];
    const selectedUrgencies = this.searchModel.urgency || [];
    const selectedRiskLevels = this.searchModel.riskLevel || [];
    const selectedBurdens = this.searchModel.burden || [];
    const selectedAmountTypes = this.searchModel.amountType || [];
    this.searchTags = [
      {
        key: 'selectedTags',
        value: tags,
        modelValue : this.searchModel.selectedTags,
        displayName: 'Tags',
        dropdownKey: '',
        selectedArrayKey: 'selectedTags'
      },
      {
        key: 'status',
        value: this.searchModel.status,
        displayName: 'Status',
        dropdownKey: '',
        selectedArrayKey: 'status'
      },
      {
        key: 'category',
        value: this.getSelectedMultiFilterLabel('category'),
        modelValue: selectedCategories,
        displayName: 'Category',
        dropdownKey: '',
        selectedArrayKey: 'category'
      },
      {
        key: 'complexity',
        value: this.getSelectedMultiFilterLabel('complexity'),
        modelValue: selectedComplexities,
        displayName: 'Complexity',
        dropdownKey: '',
        selectedArrayKey: 'complexity'
      },
      {
        key: 'urgency',
        value: this.getSelectedMultiFilterLabel('urgency'),
        modelValue: selectedUrgencies,
        displayName: 'Urgency',
        dropdownKey: '',
        selectedArrayKey: 'urgency'
      },
      {
        key: 'riskLevel',
        value: this.getSelectedMultiFilterLabel('riskLevel'),
        modelValue: selectedRiskLevels,
        displayName: 'Risk',
        dropdownKey: '',
        selectedArrayKey: 'riskLevel'
      },
      {
        key: 'burden',
        value: this.getSelectedMultiFilterLabel('burden'),
        modelValue: selectedBurdens,
        displayName: 'Burden',
        dropdownKey: '',
        selectedArrayKey: 'burden'
      },
      {
        key: 'amountType',
        value: this.getSelectedMultiFilterLabel('amountType'),
        modelValue: selectedAmountTypes,
        displayName: 'Amount Type',
        dropdownKey: '',
        selectedArrayKey: 'amountType'
      },
      {
        key: 'requiresInvestment',
        value: this.searchModel.requiresInvestment,
        displayName: 'Requires Investment',
        dropdownKey: '',
        selectedArrayKey: 'requiresInvestment'
      },
      {
        key: 'applicableTo',
        value: this.searchModel.applicableTo,
        displayName: 'Applicable To',
        dropdownKey: '',
        selectedArrayKey: 'applicableTo'
      }
    ];
    this.searchTags = this.searchTags.filter(( obj ) => {
      return obj.value;
    });
    const obj: any = {searchKey: 'tags', searchFilters};
    const searchObj = {
      ...this.searchModel,
      category: selectedCategories.join(','),
      complexity: selectedComplexities.join(','),
      urgency: selectedUrgencies.join(','),
      riskLevel: selectedRiskLevels.join(','),
      burden: selectedBurdens.join(','),
      amountType: selectedAmountTypes.join(',')
    };
    const data = {filters: this.searchTags, searchObj, selectedValues: this.searchModel.selectedTags};
    this.switchBoard.onStrategyTagsAdvSearch.next(data);
    if (closePopup) {
      this.hideReveal('search');
    }
  }

  clearAllFilters() {
    this.searchModel = {
      selectedTags: [],
      status: '',
      category: [],
      complexity: [],
      urgency: [],
      riskLevel: [],
      burden: [],
      amountType: [],
      requiresInvestment: '',
      applicableTo: ''
    };
    this.closeAllMultiSelectDropdowns();
    this.displayTags = false;
    setTimeout(() => {
      this.displayTags = true;
    });
    this.advanceTasksSearch(false);
  }

  getSelectedNames(obj, type) {
    let labels = [];
    _.forEach(obj, function (value) {
      labels.push(value[type]);
    });
    return labels.join(',');
  }

  getSelectedListInArray(array, key) {
    let list = [];
    if (array && array.length > 0) {
      _.forEach(array, function (value) {
        list.push(value[key]);
      });
    }
    return list;
  }

  onTagSelect(tag) {
    if (!_.isEmpty(tag)) {
      this.searchModel.selectedTags.push(tag);
      this.searchModel.selectedTags = _.uniqBy(this.searchModel.selectedTags, 'id');
      this.displayTags = false;
      setTimeout(() => {
        this.displayTags = true;
      });
    }

  }

  setStatus($event){
    this.searchModel.status = $event?.name || '';
  }

  setComplexity($event){
    this.searchModel.complexity = $event?.value || '';
  }

  setCategory($event){
    this.searchModel.category = $event?.value || '';
  }

  setUrgency($event){
    this.searchModel.urgency = $event?.value || '';
  }

  setRiskLevel($event){
    this.searchModel.riskLevel = $event?.value || '';
  }

  setBurden($event){
    this.searchModel.burden = $event?.value || '';
  }

  setAmountType($event){
    this.searchModel.amountType = $event?.value || '';
  }

  setRequiresInvestment($event){
    this.searchModel.requiresInvestment = $event?.value || '';
  }

  setApplicableTo($event){
    this.searchModel.applicableTo = $event?.value || '';
  }

}

